<kendo-appbar themeColor="primary">
  <kendo-appbar-section>
    <button
      themeColor="base"
      kendoButton
      [svgIcon]="menuSvg"
      fillMode="flat"
      [disabled]="!loggedIn || !user"
      title="{{ expanded ? ('COLLAPSE_MENU' | translate) : ('EXPAND_MENU' | translate) }}"
      (click)="toggleExpanded()"
    >
      @if (loadingUser) {
      <kendo-loader
        type="converging-spinner"
        size="small"
      ></kendo-loader>
      }
    </button>
  </kendo-appbar-section>
  <kendo-appbar-section>
    <img
      class="toolbar-logo"
      alt="Optinex logo"
      [attr.src]="'assets/img/fx_logo.png'"
    />
  </kendo-appbar-section>

  <kendo-appbar-spacer></kendo-appbar-spacer>

  @if (!configuration.production) {
  <kendo-appbar-section>
    <span class="environment-badge">{{ configuration.environment }}</span>
  </kendo-appbar-section>

  <kendo-appbar-spacer></kendo-appbar-spacer>
  }

  <kendo-appbar-section>
    <app-notification-popup [disabled]="!loggedIn || !user"></app-notification-popup>
  </kendo-appbar-section>

  <kendo-appbar-section>
    <button
      kendoButton
      themeColor="primary"
      fillMode="flat"
      themeColor="base"
      [svgIcon]="logoutIcon"
      title="{{ 'LOGOUT' | translate }}"
      [disabled]="!loggedIn"
      (click)="logout()"
    ></button>
  </kendo-appbar-section>
</kendo-appbar>
<div kendoDialogContainer></div>
<kendo-drawer-container>
  <kendo-drawer
    #drawer
    [width]="300"
    [items]="authenicatedNodes"
    [mode]="'overlay'"
    [mini]="false"
    [expanded]="expanded"
    (select)="onSelect($event)"
    [autoCollapse]="false"
    [hidden]="hideMenu"
    [isItemExpanded]="isItemExpanded"
  >
    <ng-template kendoDrawerHeaderTemplate>
      @if (loggedIn) {
      <app-user-settings
        (toggleExpanded)="drawer.toggle()"
        (updatedLocale)="setLang($event)"
      ></app-user-settings>
      }
    </ng-template>
    <ng-template
      kendoDrawerItemTemplate
      let-item
      let-hasChildren="hasChildren"
      isItemExpanded="isItemExpanded"
    >
      <kendo-svgicon
        [icon]="item.svgIcon"
        themeColor="primary"
        size="large"
      ></kendo-svgicon>
      <div (contextmenu)="onRightClick(item)">{{ item.text | translate }}</div>
      <div style="flex-grow: 1"></div>
      @if (hasChildren) {
      <kendo-svg-icon
        [icon]="isItemExpanded ? chevronDownIcon : chevronUpIcon"
        themeColor="primary"
      ></kendo-svg-icon>
      }
    </ng-template>
  </kendo-drawer>
  <kendo-drawer-content [ngClass]="{ 'margined-content': applyMargin, 'no-margined-content': !applyMargin }">
    <router-outlet></router-outlet>
  </kendo-drawer-content>
</kendo-drawer-container>
<app-copilot-chat-host [available]="loggedIn && user?.isDeveloper === true"></app-copilot-chat-host>
